// extracted by css-extract-rspack-plugin
export default {"salaryInfoNoWrap":"salary-info-no-wrap--ZJSFPZAMoMyQM8p8"};